import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M18.167 16.875c.916 0 1.666-.731 1.666-1.625V7.125c0-.894-.75-1.625-1.666-1.625H4.833c-.916 0-1.666.731-1.666 1.625v8.125c0 .894.75 1.625 1.666 1.625H1.5V18.5h20v-1.625h-3.333zM4.833 7.125h13.334v8.125H4.833V7.125z" }));
export default createSvgIcon(iconPath, "ResolutionLarge");
//# sourceMappingURL=ResolutionLargeIcon.js.map